import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card, StatusPill } from "../components/primitives";
import { formatNGN, formatDateTime } from "../lib/format";

export default function ReportingCTR() {
  const [ctrs, setCtrs] = useState([]);
  useEffect(() => { api.get("/reports/ctr").then(r => setCtrs(r.data.ctrs || [])); }, []);
  return (
    <div>
      <PageHeader title="CTR — Currency Transaction Reports" subtitle={`${ctrs.length} auto-generated reports · NGN ≥ ₦5,000,000`} sections={["5.8"]} />
      <div className="p-6">
        <Card>
          <table className="dense w-full">
            <thead><tr><th>CTR ID</th><th>Customer</th><th>Cust ID</th><th>Channel</th><th className="text-right">Amount</th><th>Timestamp</th><th>Status</th></tr></thead>
            <tbody>
              {ctrs.map(c => (
                <tr key={c.id}><td className="font-medium text-[12px]">{c.id}</td><td className="text-[12px]">{c.customer_name}</td><td className="text-[11px] hash-mono">{c.customer_id}</td><td className="text-[11px]">{c.channel}</td><td className="text-right tabular">{formatNGN(c.amount)}</td><td className="text-[11px]">{formatDateTime(c.ts)}</td><td><StatusPill status={c.status} /></td></tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </div>
  );
}
